const ProfilingOutput = () => {
  return (
    <p className="text-[10px]">
      Site profiling maps and analyzes key features of a location—topography,
      land use, infrastructure, and more—to help you understand its suitability
      for specific activities or developments.
    </p>
  );
};

export default ProfilingOutput;
